import React from "react";
import StatusBadge from "./StatusBadge";
import { formatNumber, formatPercent, formatSigned } from "../utils/formatters";

function KpiCard({ label, value, hint, tone = "default", children }) {
  return (
    <article className={`swb-kpi swb-kpi--${tone}`}>
      <div className="swb-kpi__label">{label}</div>
      <div className="swb-kpi__value">{value}</div>
      {hint ? <div className="swb-kpi__hint">{hint}</div> : null}
      {children}
    </article>
  );
}

export default function KPIGrid({ aggregate, isOutdated }) {
  const gapIsSlack = Number(aggregate?.gap) < 0;
  const gapLabel = gapIsSlack ? "Folga" : "Gap";
  const gapValue = gapIsSlack
    ? formatNumber(Math.abs(Number(aggregate?.gap) || 0), 1)
    : formatNumber(aggregate?.gap, 1);

  return (
    <section className="swb-kpi-grid">
      <KpiCard label="Plano" value={formatNumber(aggregate?.planTotal, 1)} hint="Volume planejado">
        {isOutdated ? <small className="swb-kpi__warn">Reexecute para atualizar</small> : null}
      </KpiCard>

      <KpiCard label="Simulado" value={formatNumber(aggregate?.simulatedTotal, 1)} hint="Capacidade simulada" />

      <KpiCard label="Realizado (mock)" value={formatNumber(aggregate?.realizedTotal, 1)} hint="Base fictícia local" />

      <KpiCard
        label="% Atendimento"
        value={formatPercent(aggregate?.attendancePct, 1)}
        hint="% simulado / plano"
        tone={Number(aggregate?.attendancePct) >= 100 ? "ok" : "warning"}
      />

      <KpiCard
        label={gapLabel}
        value={formatSigned(gapIsSlack ? Math.abs(Number(aggregate?.gap) || 0) : aggregate?.gap, 1)}
        hint={gapIsSlack ? "Capacidade excedente" : "Falta para o plano"}
        tone={gapIsSlack ? "ok" : "danger"}
      />

      <KpiCard
        label="Status"
        value={<StatusBadge status={aggregate?.status || "-"} />}
        hint="Considera tolerância configurada"
      />

      <KpiCard
        label="Gargalo principal"
        value={aggregate?.mainBottleneck || "Sem gargalo"}
        hint={`${aggregate?.rowCount || 0} linha(s) analisadas`}
      />
    </section>
  );
}
